import { UI } from '@genial/components';
import { BoxBorder, Color, Typography } from '@genial/design-tokens';
import { ISkeletonProps, Skeleton } from 'native-base';
import React from 'react';

import { CustomItem } from '../CustomItem';

export interface InfoItemProps {
  label: string;
  value?: string;
  loading?: boolean;
}

export const ColoredInfoSkeleton = (props: ISkeletonProps) => (
  <Skeleton
    endColor={Color['brand.primary.lightest']}
    w="44px"
    h={Typography['fontsize.md']}
    borderRadius={BoxBorder.heavy}
    {...props}
  />
);

export const InfoItem: React.FC<InfoItemProps> = ({ label, loading, value = '' }) => {
  return (
    <CustomItem
      label={label}
      value={
        loading ? (
          <ColoredInfoSkeleton />
        ) : (
          <UI.Text variant="semibold" color="neutral.black">
            {value}
          </UI.Text>
        )
      }
    />
  );
};
